import { httpClient } from '@/shared/api/httpClient'

import type { PublicStats, TopGame } from '../types/landing.types'

export const statsApi = {
  getPublic: (): Promise<PublicStats> =>
    httpClient.get<PublicStats>('/stats/public').then((r) => r.data),

  /** Top de juegos por nº total de partidas registradas. Default limit = 10. */
  getTopGames: (limit = 10): Promise<TopGame[]> =>
    httpClient
      .get<TopGame[]>('/stats/top-games', { params: { limit: String(limit) } })
      .then((r) => r.data),
}
